export function schema_group() {
	return {
		title: "Paramètres",
		type: "object",
		properties: {
			blocks: {
				type: "array",
				title: "Blocs",
				items: {
					type: "object",
					title: "Bloc",
					properties: {
						title: {
							title: "Titre",
							type: "string"
						},
						conditions: {
							title: "Conditions",
							type: "string"
						}
					}
				}
			}
		},
	};
}
